<template>
  <div class="yuyue-css">
    <el-image class="bglogo" :src="require('@/assets/df/bgLogo.png')" />

    <div class="video-div">
      <el-image
        class="video-title"
        v-if="!isH5"
        :src="require('@/assets/df/title.png')"
      />
      <el-image
        class="video-title"
        v-else
        :src="require('@/assets/df/h5title.png')"
      />
      <el-image
        class="video-play"
        :src="require('@/assets/df/play.png')"
        @click="openVideo"
      />
    </div>

    <!-- 视频遮罩层 -->
    <div class="video-overlay" v-if="showVideo" @click="closeVideo">
      <video
        ref="videoRef"
        class="video-player"
        :src="videoSrc"
        autoplay
        controls
        @click.stop
      ></video>
    </div>

    <el-image class="video-title2" :src="require('@/assets/df/title2.png')" />

    <!-- 预约数量展示 -->
    <div class="yuyue-count">
      <img
        class="count-bg"
        v-if="!isH5"
        :src="require('@/assets/df/coutbg.png')"
      />
      <img class="count-bg" v-else :src="require('@/assets/df/h5coutbg.png')" />

      <div class="count-text">{{ yy_num }}</div>
    </div>
    <!-- 预约按钮 -->
    <div class="pre-div">
      <div class="cout-down">
        <img class="countdown-bg" :src="require('@/assets/df/cdpic.png')" />

        <!-- 倒计时 -->
        <div class="cd-num">
          <span>{{ countdown }}</span>
        </div>
      </div>

      <img
        class="pre-btn"
        :src="
          booked
            ? require('@/assets/df/preEnd.png')
            : require('@/assets/df/buttonpre.png')
        "
        @click="handlePreBtnClick"
      />
    </div>

    <!-- 弹窗 -->
    <div class="dialog-overlay" v-if="showDialog">
      <div class="dialog-box">
        <img
          class="dialog-close"
          :src="require('@/assets/df/closebtn.png')"
          @click="closeDialog"
        />
        <div class="dialog-title">Please enter your Email</div>
        <input class="dialog-input" v-model="email" type="email" />
        <img
          class="dialog-confirm"
          :src="require('@/assets/df/confirmbtn.png')"
          @click="confirm"
        />
      </div>
    </div>
    <!-- 社区 -->
    <div class="community">
      <img
        class="community-icon"
        :src="require('@/assets/df/facebook.png')"
        @click="goCommunity('facebook')"
      />
      <img
        class="community-icon"
        :src="require('@/assets/df/discord.png')"
        @click="goCommunity('discord')"
      />
    </div>

    <!-- 页脚 -->
    <div class="pre-footer">
      <a type="text" class="ys" :href="$t(`Secret.src`)" target="blank">{{
        $t(`Nav.secret`)
      }}</a>
      <a type="text" class="ys" :href="$t(`Terms.src`)" target="blank">{{
        $t(`Nav.terms`)
      }}</a>
    </div>
  </div>
</template>

<script>
import { getDeviceId } from '@/utils/request'
import { ElMessage } from 'element-plus'
import md5 from 'js-md5'
import { getCurrentInstance, onMounted, onUnmounted, ref } from 'vue'

export default {
  name: `zbb`,
  setup() {
    const { proxy } = getCurrentInstance()

    const isH5 = ref(false)
    const mediaQuery = window.matchMedia('(max-width: 750px)')
    const onMediaChange = (e) => {
      isH5.value = e.matches
    }

    // 倒计时目标时间：北京时间 9月28日 10:00（UTC+8，即 UTC 02:00）
    const targetTime = Date.UTC(2026, 8, 28, 2, 0, 0)
    const countdown = ref('00:00:00')
    let countdownTimer = null

    const updateCountdown = () => {
      const diff = targetTime - Date.now()
      if (diff <= 0) {
        countdown.value = '00:00:00'
        if (countdownTimer) {
          clearInterval(countdownTimer)
          countdownTimer = null
        }
        return
      }
      const hours = Math.floor(diff / 3600000)
      const minutes = Math.floor((diff % 3600000) / 60000)
      const seconds = Math.floor((diff % 60000) / 1000)
      countdown.value = [hours, minutes, seconds]
        .map((v) => String(v).padStart(2, '0'))
        .join(':')
    }

    const yy_num = ref(0)
    // 初始化接口
    const initData = async () => {
      try {
        const res = await proxy.$axios.post(
          '/v3/Booking/initData?game_id=633a07f3c76e344b&channel_id=yy',
          { game_no: 201 },
        )
        yy_num.value = res.data.yy_number
      } catch (e) {
        console.error('initData error:', e)
      }
    }

    onMounted(() => {
      isH5.value = mediaQuery.matches
      mediaQuery.addEventListener('change', onMediaChange)
      initData()
      showBookingSuccess()
      document.addEventListener('visibilitychange', onVisibilityChange)
      // 启动倒计时
      updateCountdown()
      countdownTimer = setInterval(updateCountdown, 1000)
    })
    onUnmounted(() => {
      mediaQuery.removeEventListener('change', onMediaChange)
      document.removeEventListener('visibilitychange', onVisibilityChange)
      if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
      }
    })

    // 是否已预约
    const booked = ref(localStorage.getItem('df_booked') === '1')

    // 设备判断
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)

    // 返回页面时弹出预约成功提示
    const showBookingSuccess = () => {
      if (localStorage.getItem('df_booking_success') === '1') {
        localStorage.removeItem('df_booking_success')
        ElMessage.success(proxy.$t('Booking.success'))
      }
    }

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        showBookingSuccess()
      }
    }

    const communityLinks = {
      facebook: 'https://www.facebook.com/profile.php?id=61589437860611',
      discord: 'https://discord.gg/5VdNtF2aBz',
      ios: 'https://apps.apple.com/us/app/deadfront-zombie-survival-rpg/id6781503453',
      android:
        'https://play.google.com/store/apps/details?id=com.hongyu.deadfront',
    }

    const goCommunity = (type) => {
      window.open(communityLinks[type], '_blank')
    }

    const showDialog = ref(false)
    const email = ref('')

    const showVideo = ref(false)
    const videoRef = ref(null)
    const videoSrc = require('@/assets/df/video.mp4')

    const openVideo = () => {
      showVideo.value = true
    }

    const closeVideo = () => {
      if (videoRef.value) {
        videoRef.value.pause()
        videoRef.value.currentTime = 0
      }
      showVideo.value = false
    }

    const openDialog = () => {
      showDialog.value = true
      email.value = ''
    }

    const closeDialog = () => {
      showDialog.value = false
    }

    // 已预约后按钮不可点击
    const handlePreBtnClick = () => {
      if (booked.value) {
        return
      }
      openDialog()
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    // 防抖，防止接口重复提交
    let confirmLock = false

    const confirm = async () => {
      if (confirmLock) {
        return
      }
      if (!email.value) {
        ElMessage.warning('Please enter your email')
        return
      }
      if (!emailRegex.test(email.value)) {
        ElMessage.warning('Please enter a valid email address')
        return
      }
      confirmLock = true
      const deviceId = getDeviceId()
      const sign = md5('201' + email.value + deviceId)
      try {
        const res = await proxy.$axios.post(
          '/v3/Booking/bookNow?game_id=633a07f3c76e344b&channel_id=yy',
          {
            game_no: 201,
            email: email.value,
            sign,
          },
        )
        if (res.code === 200) {
          // 记录已预约状态
          localStorage.setItem('df_booked', '1')
          booked.value = true
          // 判断设备并跳转对应商店链接
          const link = isIOS ? communityLinks.ios : communityLinks.android
          if (link) {
            localStorage.setItem('df_booking_success', '1')
            window.location.href = link
          } else {
            showDialog.value = false
            // 更新预定人数
            initData()
            ElMessage.success(proxy.$t('Booking.success'))
          }
        } else {
          ElMessage.error(res.message || 'Booking failed')
        }
      } catch (e) {
        console.error('bookNow error:', e)
        ElMessage.error('Booking failed')
      } finally {
        setTimeout(() => {
          confirmLock = false
        }, 1000)
      }
    }

    return {
      isH5,
      yy_num,
      countdown,
      booked,
      goCommunity,
      showDialog,
      email,
      openDialog,
      closeDialog,
      handlePreBtnClick,
      confirm,
      showVideo,
      videoRef,
      videoSrc,
      openVideo,
      closeVideo,
    }
  },
}
</script>
<style scoped lang="less">
@import '@/assets/css/yuyue.css';
</style>
